import {appendQueryString, getRequest} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {IPaginatedResponse} from "../../request/IResponse";
import {IPropertyConfiguratorProperty} from "../types/IPropertyConfiguratorProperty";
import {IFetchParams} from "../utils/get_property_api_params";

export interface IParams extends IFetchParams {
    page?: number;
}

export interface IOfferDetailPropertiesResponse extends IPaginatedResponse {
    results: IPropertyConfiguratorProperty[];
}

export const fetchFirstProperties = (params: IParams) => {
    const url = appendQueryString(apiV2ListLink.property.configurator(Scenario.PROPERTY_CONFIGURATOR_LIST), {
        ...params,
        distinct_offers: 1
    });

    return getRequest({}, url).then((json: IOfferDetailPropertiesResponse) => {
        return json;
    });
};
import {appendQueryString, getRequest} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {IPaginatedResponse} from "../../request/IResponse";
import {IPropertyConfiguratorProperty} from "../types/IPropertyConfiguratorProperty";
import {IFetchParams} from "../utils/get_property_api_params";

export interface IParams extends IFetchParams {
    page?: number;
}

export interface IOfferDetailPropertiesResponse extends IPaginatedResponse {
    results: IPropertyConfiguratorProperty[];
}

export const fetchFirstProperties = (params: IParams) => {
    const url = appendQueryString(apiV2ListLink.property.configurator(Scenario.PROPERTY_CONFIGURATOR_LIST), {
        ...params,
        distinct_offers: 1
    });

    return getRequest({}, url).then((json: IOfferDetailPropertiesResponse) => {
        return json;
    });
};
